import * as go from 'gojs';
import { getImageFeederAndScreen } from 'unitData/Feeders/FeederScreen/getImageFeederScreen';
import {
  getImageBinding,
  getIOPort,
  makeNode,
  getDeckPortPanel,
} from '../../utils';

const alignFeederPorts = (mirrored: boolean, portIndex: number) => {
  const x = mirrored ? 0 : 1;

  switch (portIndex) {
    case 0:
      return new go.Spot(x, 4 / 6);
    case 1:
      return new go.Spot(x, 5 / 6);
    case 2:
      return go.Spot.Bottom;
  }
};

const FeederAndScreenTemplate = makeNode(
  getImageBinding('', getImageFeederAndScreen),
  [
    getIOPort(go.Spot.Top, 'input'),
    getDeckPortPanel(0, alignFeederPorts),
    getDeckPortPanel(1, alignFeederPorts),
    getDeckPortPanel(2, alignFeederPorts),
  ],
  {
    imageMargin: 0,
    imageSize: { width: 88, height: 88 },
  },
);

export default FeederAndScreenTemplate;
